import { defineComponent } from 'vue';
import ExerciseListItem from '@/components/list/exercieseItem.vue';
import ListWrapper from './listWrapper.vue';
import { getExerciseList } from '@/api/api';
import { getUserId } from '@/widget';
export default defineComponent({
    props: {
        size: {
            default: '',
            type: String
        },
        moduleId: {
            type: Number
        },
        subDepId: {
            type: Number
        },
        diseaseId: {
            type: Number
        },
        flagBl: {
            type: Boolean,
            default: false
        },
        labelId: {
            default: 0
        },
        labelType: {
            default: 'root'
        }
    },
    data() {
        return {
            list: [],
            pageNo: 1,
            flag: true,
            pageCount: 1
        };
    },
    watch: {
        flagBl(newData) {
            if (newData && this.moduleId === 0) {
                this.pageNo = 1;
                this.getList();
            }
        },
        diseaseId(newData) {
            if (newData && this.flagBl) {
                this.pageNo = 1;
                this.getList();
            }
        }
    },
    methods: {
        getList() {
            getExerciseList({
                params: {
                    userId: getUserId()
                },
                query: {
                    pageNo: this.pageNo,
                    pageSize: 2,
                    labelId: this.labelId,
                    labelType: this.labelType
                }
            }).then(res => {
                this.$hideLoading();
                this.flag = true;
                if (res.code === 200) {
                    if (this.pageNo === 1) {
                        this.list = res.data.list;
                        this.$emit('initFlag');
                    }
                    else {
                        this.list = this.list.concat(res.data.list);
                    }
                    this.pageCount = res.data.pageCount;
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        showMore() {
            if (this.flag) {
                this.pageNo = this.pageNo + 1;
                this.flag = false;
                this.$showLoading();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        }
    },
    components: {
        ExerciseListItem,
        ListWrapper
    }
});
